import React, { FC, useEffect, useState } from 'react';
import { Pagination, Table } from 'antd';
import { useAppDispatch, useAppSelector } from 'common/hooks';
import { DEFAULT_PAGINATION_PAGE, LIST_LIMIT } from 'common/config';
import { renderAssessmentHistoryRecords } from 'entities/PatientMetrics/PatientMetrics.helper';

interface IComponentProps {
  patientId?: number;
}

export const AssessmentHistory: FC<IComponentProps> = ({ patientId }) => {
  const { assessmentHistory, count, loading } = useAppSelector((state) => ({
    assessmentHistory: state.patientMetrics.data,
    count: state.patientMetrics.count,
    loading: state.patientMetrics.loading,
  }));
  const { patientMetrics: patientMetricsDispatch } = useAppDispatch();
  const [page, setPage] = useState(DEFAULT_PAGINATION_PAGE);

  useEffect(() => {
    if (patientId) {
      patientMetricsDispatch.getAssessmentHistory({
        patientId,
        limit: LIST_LIMIT,
        offset: LIST_LIMIT * (page - 1),
      });
    }
  }, [patientId, page]);

  return (
    <div>
      <div className="mb-8 d-flex align-center justify-between">
        <div className="ff-medium" style={{ fontSize: 20 }}>
          Assessment History
        </div>

        <a
          onClick={() => {
            window.open(
              `https://dev.celerihealth.com/home/resources/scheduleds/new?viaResource=patients&viaResourceId=${patientId}&viaRelationship=scheduled`,
              '_blank',
            );
          }}
        >
          Send Assessment to Patient
        </a>
      </div>

      <div className="mb-9">
        <Table
          dataSource={assessmentHistory.map((history, index) => ({ ...history, key: index }))}
          columns={renderAssessmentHistoryRecords()}
          pagination={false}
          loading={loading}
        />
      </div>

      <Pagination current={page} total={count} showSizeChanger={false} onChange={setPage} defaultPageSize={LIST_LIMIT} />
    </div>
  );
};
